export default "__VITE_ASSET__mAc2Sn5g__"